import { useEffect } from "react";

export interface useOnScrollOptions {
    onScroll: () => void;
    loading?: boolean;
    scrollThreshold?: number;
    disable?: boolean;
}

export const useOnScroll = ({
    onScroll,
    loading = false,
    disable = false,
    scrollThreshold = 200
}: useOnScrollOptions) => {
    useEffect(() => {
        if (disable || !onScroll) return;

        // If the user is at the bottom of the page, load more items
        const handleScroll = () => {
            if (
                !loading &&
                window.innerHeight + window.scrollY >=
                    document.body.offsetHeight - scrollThreshold
            ) {
                onScroll();
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [loading, onScroll, disable, scrollThreshold]);
};
